import React from 'react'

function SendNoteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M10.586 10.196a.778.778 0 0 1 .173-.261l6.5-6.5a2.338 2.338 0 0 1 3.306 3.306l-6.5 6.5a.778.778 0 0 1-.261.173L9.285 15.22a.39.39 0 0 1-.506-.506l1.807-4.519ZM19.753 7.555l-3.307-3.307"
      />
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M11.25 2.75h-4.5a4 4 0 0 0-4 4v10.5a4 4 0 0 0 4 4h10.5a4 4 0 0 0 4-4v-4.5"
      />
    </svg>
  )
}
export default SendNoteIcon
